import React from 'react';
import { VStack } from 'native-base';
import { Member } from '@springbig/shared';
import { Caption } from '~/shared/Typography';
import { useGeneralStyles, useReferStyles } from '~/shared/styles';
import Button from '~/shared/Button';

type ReferCopyLinkProps = {
    copyToClipboard: (link: string) => void;
    link: string;
    member?: Member | null;
    rounded?: 'none' | 'sm' | 'DEFAULT' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | 'full';
    isHideText?: boolean;
};

const ReferCopyLink = ({
    copyToClipboard,
    link,
    member,
    rounded = 'sm',
    isHideText = false,
}: ReferCopyLinkProps) => {

    const {
        text
    } = useReferStyles();
    const gStyle = useGeneralStyles();

    return (
        <VStack w={'100%'} alignItems={'center'} space={2}>
            { !isHideText &&
                <Caption
                    color={text}
                    text='refer.text_link'
                    textAlign={'center'}
                />
            }
            { !isHideText &&
                <Caption
                    fontWeight={'bold'}
                    color={gStyle.link}
                    textAlign={'center'}
                >
                    { member && member.referrals?.link }
                </Caption>
            }
            <Button
                testID='refer-copy-link-btn'
                bg={gStyle.button_background}
                px={8}
                py={2}
                rounded={rounded}
                onPress={() => copyToClipboard(undefined)}
            >
                <Caption
                    fontWeight={300}
                    fontSize={16}
                    color={gStyle.button_text}
                >
                    { link }
                </Caption>
            </Button>
        </VStack>
    );
};

export default ReferCopyLink;
